import { createSelector } from 'reselect';
import { ReduxState } from '../../../../ReduxStorage/state';
import {
  CohortTimelinePageState,
  CohortTimelinePageData,
  ErrorMessageType,
  CohortTimeLineAutoSaveStates,
} from './types';
import { INITIAL_STATE } from './store';
import { currentCohortScheduleData } from '../../../../ReduxStorage/Cohorts/selectors';
import { CohortScheduleData } from '../../../../ReduxStorage/Cohorts/CohortTypes';

const selectCohortTimelinePageState = (
  state: ReduxState
): CohortTimelinePageState => state.CohortTimelinePage || INITIAL_STATE;

export const selectCohortTimelineUpdateStatus = createSelector(
  selectCohortTimelinePageState,
  (state: CohortTimelinePageState): ErrorMessageType | null => {
    return state.errorMessage;
  }
);

export const selectCurrentUtcoffset = createSelector(
  selectCohortTimelinePageState,
  (state: CohortTimelinePageState): string => {
    return state.utcoffset;
  }
);

export const selectCurrentTimelinePageUpdate = createSelector(
  currentCohortScheduleData,
  selectCurrentUtcoffset,
  (
    cohortScheduleData: CohortScheduleData | null,
    utcoffset: string
  ): CohortTimelinePageData | null => {
    return cohortScheduleData
      ? Object.assign(cohortScheduleData, { utcoffset })
      : null;
  }
);

export const selectCohortTimelinAutoSaveStates = createSelector(
  selectCohortTimelinePageState,
  (state: CohortTimelinePageState): CohortTimeLineAutoSaveStates | null => {
    return state.autoSaveStates;
  }
);
